@if (banner2Model != undefined){
<section class="support-section" aria-labelledby="support-title">
  <div class="support-container">
    <div class="support-text">
      <h2 id="support-title">{{ banner2Model.title }}</h2>

      <ul role="list">
        <li class="publish-point">
          <span class="icon-check" aria-hidden="true"></span>
          <span class="point-text">{{banner2Model.text1 }}</span>
        </li>
        <li class="publish-point">
          <span class="icon-check" aria-hidden="true"></span>
          <span class="point-text">{{banner2Model.text2 }}</span>
        </li>
        <li class="publish-point">
          <span class="icon-check" aria-hidden="true"></span>
          <span class="point-text">{{banner2Model.text3 }}</span>
        </li>
        <li class="publish-point">
          <span class="icon-check" aria-hidden="true"></span>
          <span class="point-text">{{banner2Model.text4 }}</span>
        </li>
        <li class="publish-point">
          <span class="icon-check" aria-hidden="true"></span>
          <span class="point-text">{{banner2Model.text5 }}</span>
        </li>

      </ul>
      <div class="hero-buttons">
        <a [routerLink]="['/', currentLang(), 'pricing']" class="btn-primary" title="{{ banner2Model.buttonText }}">
          {{ banner2Model.buttonText }}
        </a>
      </div>
    </div>
    <div class="support-image">
      <img src="/assets/images/image2.webp" [alt]="banner2Model.title"  width="488" height="304" >
    </div>
  </div>
  <script type="application/ld+json">
  {
    "@context": "https://schema.org",
    "@type": "ItemList",
    "name": {{ '"' + (banner2Model.title) + '"' }},
    "itemListElement": [
      { "@type": "ListItem", "position": 1, "name": {{ '"' + (banner2Model.text1) + '"' }} },
      { "@type": "ListItem", "position": 2, "name": {{ '"' + (banner2Model.text2) + '"' }} },
      { "@type": "ListItem", "position": 3, "name": {{ '"' + (banner2Model.text3) + '"' }} },
      { "@type": "ListItem", "position": 4, "name": {{ '"' + (banner2Model.text4) + '"' }} },
      { "@type": "ListItem", "position": 5, "name": {{ '"' + (banner2Model.text5) + '"' }} }
    ]
  }
  </script>
</section>
}